module.exports = __webpack_public_path__ + "static/media/horrormax-banner-eternal-damn-nation.285bf034.jpg";